(function () {
  'use strict';

  // --- Sticky nav ---
  var nav = document.getElementById('site-nav');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // --- Scroll reveals ---
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  // --- Filter buttons (visual only on homepage) ---
  document.querySelectorAll('[data-filters]').forEach(function (container) {
    var btns = container.querySelectorAll('.filter');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
      });
    });
  });

  // --- Testimonial rotator ---
  var tiRoot = document.querySelector('[data-testimonials]');
  if (tiRoot) {
    var tiText = tiRoot.querySelector('.testi-quote');
    var tiMeta = tiRoot.querySelector('.testi-meta');
    var dots = tiRoot.querySelectorAll('.testi-dots button');
    var data = [];
    tiRoot.querySelectorAll('[data-testi]').forEach(function (el) {
      data.push({ quote: el.dataset.quote, meta: el.dataset.meta });
    });
    if (data.length > 1) {
      var ti = 0;
      var setTesti = function (i) {
        ti = i;
        tiText.style.opacity = 0;
        tiMeta.style.opacity = 0;
        setTimeout(function () {
          tiText.innerHTML = data[i].quote;
          tiMeta.innerHTML = data[i].meta;
          tiText.style.transition = 'opacity 0.4s';
          tiMeta.style.transition = 'opacity 0.4s';
          tiText.style.opacity = 1;
          tiMeta.style.opacity = 1;
        }, 200);
        dots.forEach(function (d, j) { d.classList.toggle('active', i === j); });
      };
      dots.forEach(function (d) {
        d.addEventListener('click', function () { setTesti(parseInt(d.dataset.i, 10)); });
      });
      setInterval(function () { setTesti((ti + 1) % data.length); }, 6000);
    }
  }

  // --- Hero belt parallax ---
  var heroVisual = document.querySelector('.hero-visual');
  if (heroVisual && window.matchMedia('(pointer:fine)').matches) {
    heroVisual.addEventListener('mousemove', function (e) {
      var r = heroVisual.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      var svg = heroVisual.querySelector('.hero-belt-svg');
      if (svg) svg.style.transform = 'translate(calc(-50% + ' + (x * 20) + 'px), calc(-50% + ' + (y * 12) + 'px)) rotate(' + (x * 3) + 'deg)';
    });
    heroVisual.addEventListener('mouseleave', function () {
      var svg = heroVisual.querySelector('.hero-belt-svg');
      if (svg) svg.style.transform = '';
    });
  }

  // --- Newsletter AJAX feedback (Shopify contact form) ---
  document.querySelectorAll('form[data-newsletter]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.textContent = 'Subscribing...'; btn.disabled = true; }
    });
  });

  // --- PDP variant picker ---
  var pdp = document.querySelector('[data-product-form]');
  if (pdp) {
    var variantData = JSON.parse(pdp.dataset.variants || '[]');
    var idInput = pdp.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var addBtn = pdp.querySelector('.pdp-add');
    var selectedOptions = {};

    pdp.querySelectorAll('.pdp-variants').forEach(function (group) {
      var optionIndex = parseInt(group.dataset.optionIndex, 10);
      var firstActive = group.querySelector('.pdp-variant.active');
      if (firstActive) selectedOptions[optionIndex] = firstActive.dataset.value;

      group.querySelectorAll('.pdp-variant').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.classList.contains('sold-out')) return;
          group.querySelectorAll('.pdp-variant').forEach(function (x) { x.classList.remove('active'); });
          b.classList.add('active');
          selectedOptions[optionIndex] = b.dataset.value;
          updateVariant();
        });
      });
    });

    function updateVariant() {
      var match = variantData.find(function (v) {
        return Object.keys(selectedOptions).every(function (i) {
          return v['option' + (parseInt(i, 10) + 1)] === selectedOptions[i];
        });
      });
      if (match) {
        if (idInput) idInput.value = match.id;
        if (priceEl) {
          var html = '';
          if (match.compare_at_price && match.compare_at_price > match.price) {
            html += '<span class="old">' + formatMoney(match.compare_at_price) + '</span>';
          }
          html += formatMoney(match.price);
          priceEl.innerHTML = html;
        }
        if (addBtn) {
          if (match.available) { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }
          else { addBtn.disabled = true; addBtn.textContent = 'Sold out'; }
        }
      }
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  // --- Quantity steppers ---
  document.querySelectorAll('[data-qty]').forEach(function (group) {
    var input = group.querySelector('input');
    var minus = group.querySelector('[data-qty-minus]');
    var plus = group.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(1, parseInt(input.value, 10) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
      input.dispatchEvent(new Event('change'));
    });
  });

  // --- PDP gallery thumbs ---
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('.pdp-main-img img');
    gal.querySelectorAll('.pdp-thumbs img').forEach(function (t) {
      t.addEventListener('click', function () {
        gal.querySelectorAll('.pdp-thumbs img').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        if (main) main.src = t.dataset.full || t.src;
      });
    });
  });

  // --- Year injection ---
  var y = document.getElementById('copyright-year');
  if (y) y.textContent = new Date().getFullYear();

  // --- Update cart count badge after adding to cart via theme buttons ---
  function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    });
  }
  refreshCartCount();

  // --- Quick add on homepage product cards ---
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      var id = btn.dataset.variantId;
      if (!id) { window.location.href = btn.dataset.url || '/'; return; }
      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added ✓';
        refreshCartCount();
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1400);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
      });
    });
  });

})();
